import { jsxs as t, jsx as C } from "react/jsx-runtime";
import i from "../svg-icon/svg-icon.component.js";
function n(l) {
  return /* @__PURE__ */ t(
    i,
    {
      width: "296",
      height: "180",
      viewBox: "0 0 296 180",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            opacity: "0.9",
            d: "M156.481 102.718C157.709 96.5568 163.102 91.035 168.1 91.035C170.206 91.035 172.189 91.6509 173.925 92.7375C176.604 86.973 181.814 83.0618 187.803 83.0618C193.934 83.0618 199.249 87.1611 201.867 93.1517C204.059 91.7999 206.555 91.035 209.204 91.035C215.05 91.035 220.155 94.7625 222.886 100.303C225.228 105.053 220.706 109.573 215.41 109.573H164.041C159.814 109.573 155.655 106.863 156.481 102.718Z",
            fill: "#6B0D41"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M71.4588 113.979C73.2564 106.452 80.031 99.834 86.3205 99.834C89.0362 99.834 91.5939 100.61 93.8339 101.978C97.2887 94.7189 104.009 89.7937 111.734 89.7937C119.642 89.7937 126.498 94.9558 129.874 102.5C132.702 100.797 135.922 99.834 139.338 99.834C146.586 99.834 152.95 104.17 156.562 110.702C160.037 116.987 153.891 123.178 146.709 123.178H81.4581C75.7714 123.178 70.1378 119.511 71.4588 113.979Z",
            fill: "#4D0A2E"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M191.461 102.847C186.819 104.517 181.783 105.432 176.521 105.432C153.298 105.432 134.472 87.6157 134.472 65.6388C134.472 60.6592 135.438 55.8932 137.204 51.4997C121.356 57.2016 110.095 71.71 110.095 88.7076C110.095 110.685 128.921 128.5 152.144 128.5C170.105 128.5 185.436 117.843 191.461 102.847Z",
            fill: "#EEDFE7"
          }
        )
      ]
    }
  );
}
export {
  n as StatusIlustrationDeclineIllustration
};
//# sourceMappingURL=status-ilustration-decline.js.map
